import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Input } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Search as SearchIcon } from '@mui/icons-material';
import styles from './styles';

const SearchInput = ({ classes, className, onChange = () => {}, style, ...rest }) => {

  const rootClassName = classNames(classes.root, className);

  return (
    <div
      className={rootClassName}
      style={style}
    >
      <SearchIcon className={classes.icon} />
      <Input
        {...rest}
        className={classes.input}
        disableUnderline
        onChange={onChange}
      />
    </div>
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  style: PropTypes.object
};

// defaultProps removed in favor of default parameters

export default withStyles(styles)(SearchInput);
